import { Link } from 'react-router-dom';
import { courseSelectorItems } from '@/mocks/coursesData';
import { useTranslation } from 'react-i18next';

export default function CourseSelector() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('courses.selector.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('courses.selector.title')}
          </h2>
          {String(t('courses.selector.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('courses.selector.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {courseSelectorItems.map((item, idx) => (
            <Link
              key={idx}
              to={item.href}
              className="card-glow group block bg-background-100/60 border border-background-200/60 p-6 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 rounded-full mb-4 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${item.icon} text-accent-600 text-base`}></i>
              </div>
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {t(`courses.selector.${idx}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">
                {t(`courses.selector.${idx}.description`)}
              </p>
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors mt-auto">
                <span className="text-[13px] tracking-[0.06em]">{t('courses.selector.viewDetail')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">
          {t('courses.selector.consultationNote')}
          <Link to="/consultation" className="text-accent-600 hover:text-accent-500 transition-colors">
            {t('courses.selector.consultationLink')}
          </Link>
          {t('courses.selector.consultationSuffix')}
        </p>
      </div>
    </section>
  );
}